import {
    MERCHANT_ACCOUNTING_ROUTE,
    MERCHANT_ACCOUNTING_PRODUCT_SALES,
    MERCHANT_ACCOUNTING_ORDERS,
    MERCHANT_ACCOUNTING_SUBSCRIPTIONS,
    MERCHANT_ACCOUNTING_CASH_REGISTER,
    MERCHANT_ACCOUNTING_CUSTOMERS,
    MERCHANT_ACCOUNTING_Z_REPORT,
    MERCHANT_ACCOUNTING_CUSTOMER_BALANCE,
    MERCHANT_CUSTOM_REPORTS_ROUTE,
    MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE,
} from "../../../../constants/routes"
import { faFileInvoiceDollar, faHome } from "@fortawesome/pro-light-svg-icons"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"

type Props = Readonly<{}>

export function MerchantAccountingNavItems({}: Props) {
    return (
        <>
            <LocalizedStrict id="merchant-nav-item-home">
                <NavMenuItem icon={faHome} dest={MERCHANT_ACCOUNTING_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-nav-item-accounting-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    icon={faFileInvoiceDollar}
                    dest={MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}
                    title="Accounting"
                >
                    <LocalizedStrict id="merchant-nav-item-accounting-product-sales">
                        <NavMenuSubItem route={MERCHANT_ACCOUNTING_PRODUCT_SALES}>Product sales</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-accounting-orders">
                        <NavMenuSubItem route={MERCHANT_ACCOUNTING_ORDERS}>Orders</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-accounting-subscriptions">
                        <NavMenuSubItem route={MERCHANT_ACCOUNTING_SUBSCRIPTIONS}>Subscriptions</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-accounting-cash-register">
                        <NavMenuSubItem route={MERCHANT_ACCOUNTING_CASH_REGISTER}>Cash Register</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-accounting-customers">
                        <NavMenuSubItem route={MERCHANT_ACCOUNTING_CUSTOMERS}>Customers</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-accounting-customer-balance">
                        <NavMenuSubItem route={MERCHANT_ACCOUNTING_CUSTOMER_BALANCE}>Customer balance</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-accounting-z-report">
                        <NavMenuSubItem route={MERCHANT_ACCOUNTING_Z_REPORT}>Z-report</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test]}>
                        <LocalizedStrict id="merchant-nav-item-accounting-custom-reports">
                            <NavMenuSubItem route={MERCHANT_CUSTOM_REPORTS_ROUTE}>Custom reports</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
